import { IMedia } from "@/interfaces/media.interface";

interface StickerProps {
  media: IMedia;
  mediaURL: string;
}

const StickerMedia: React.FC<StickerProps> = ({ media, mediaURL }) => {
  return <img width={200} height={200} src={mediaURL} alt={media.caption || media.name} />;
};

export default StickerMedia;
